export default {
    'name': 'check',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M21.9687 6.33977C22.3592 5.94924 22.3592 5.31608 21.9687 4.92555C21.5782 4.53503 20.945 4.53503 20.5545 4.92555L8.5269 16.9531L3.44551 11.8717C3.05499 11.4812 2.42182 11.4812 2.0313 11.8717C1.64077 12.2623 1.64077 12.8954 2.0313 13.286L7.81979 19.0745C8.21032 19.465 8.84348 19.465 9.23401 19.0745L21.9687 6.33977Z\' fill=\'#FF4171\'/>'
}
